import { useEffect, useRef, useState } from 'react';
import DeviceEdit from './DeviceEdit';
import WebUniversal, { getService, WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import { Badge, Button, Space, Tag, Tooltip } from 'antd';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import dayjs from 'dayjs';
import DeviceSendMsg from './DeviceSendMsg';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'device';
    const [modalVisibleDeviceSendMsg, setModalVisibleDeviceSendMsg] = useState<boolean>(false);
    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();
    const [deviceModelData, setDeviceModelData] = useState<any>();
    const [deviceStatusData, setDeviceStatusData] = useState<any>();
    const [protocolModeData, setProtocolModeData] = useState<any>();
    const [deviceSendMsgData, setDeviceSendMsgData] = useState<any>();
    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService, {
            query: {
                apiId: 'deviceModel',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setDeviceModelData([{ id: 'ALLITEM', modelName: '所有' }, ...res.data]);
            }
        });
        fetchApi.GET(getService('bm'), {
            query: {
                apiId: 'generalData',
                apiVariable: 'deviceStatus@protocolMode',
                apiExtend: 'showLists'
            }
        }).then(res => {
            if (res.success) {
                const { deviceStatus, protocolMode } = res.data;
                setDeviceStatusData([{ id: 'ALLITEM', name: '所有' }, ...deviceStatus]);
                setProtocolModeData([{ id: 'ALLITEM', name: '所有' }, ...protocolMode]);
            }
        });
    }, []);

    // 表头
    const columnsHead = [
        {
            title: '',
            dataIndex: 'isNew',
            render: (val: boolean) =>
                val ? (
                    <Tag style={{
                        color: '#fff',
                        background: '#ff4d4f',
                        borderColor: '#ff4d4f',
                    }}>新设备</Tag>
                ) : null
        },
        {
            title: '设备名',
            dataIndex: 'deviceName'
        },
        {
            title: '序列号',
            dataIndex: 'serialNumber',
            render: (val: string) =>
                <Tooltip placement="topLeft" title={val}>{
                    val?.length >= 8 ? val?.substring(0, 8) + '......' : val
                }</Tooltip>
        },
        {
            title: '型号',
            dataIndex: ['deviceModel', 'modelName'],
            render: (val: string) => val || '-'
        },
        {
            title: 'MAC地址',
            dataIndex: 'macAddress',
            render: (val: string) => val || '-'
        },
        {
            title: 'IP地址',
            dataIndex: 'ipAddress',
            render: (val: string) => val || '-'
        },
        {
            title: '通信协议',
            dataIndex: 'protocolModeId',
            render: (val: string) => val || '-'
        },
        {
            title: '设备状态',
            dataIndex: 'deviceStatus',
            render: (val: any) =>
                val ? <Tag color={val?.color || 'default'}>{val?.name}</Tag> : '-'
        },
        {
            title: '安装位置',
            dataIndex: 'location',
            render: (val: string) => val
                ? <Tooltip placement="topLeft" title={val}>
                    {val.length >= 10 ? val.substring(0, 10) + '......' : val}
                </Tooltip>
                : '-'
        },
        {
            title: '最后在线',
            dataIndex: 'lastOnlineAt',
            render: (val: string) =>
                val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : '-'
        },
        {
            title: '排序',
            dataIndex: 'sort'
        },
        {
            title: '发信息',
            dataIndex: 'id',
            render: (val: string) => (
                <Button onClick={() => {
                    setDeviceSendMsgData({
                        deviceId: val
                    })
                    setModalVisibleDeviceSendMsg(true);
                }}>发信息</Button>
            )
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '设备',
        apiId,
        columns,
        serviceId: 'mf',
        editOptions: {
            Editor: DeviceEdit
        }
    };

    return (
        <>
            <Space>
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='deviceModelId'
                    getListData={deviceModelData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                    itemName="modelName"
                />
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='deviceStatusId'
                    getListData={deviceStatusData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                />
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='protocolModeId'
                    getListData={protocolModeData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                />
            </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalVisibleDeviceSendMsg ?
                (<DeviceSendMsg
                    closeModal={() => setModalVisibleDeviceSendMsg(false)}
                    {...deviceSendMsgData} />)
                : null}
        </>
    );
};

export default WebComponent;